import { useState } from "react";
import { motion } from "framer-motion";
import { METHOD_STEPS } from "@/data/site";
import { Eyebrow, FadeIn } from "@/components/blocks";

export default function Method() {
  const [active, setActive] = useState(0);

  return (
    <section id="method" data-testid="method-section" className="bg-ink px-6 py-28 text-bone sm:px-10 sm:py-40 lg:px-16">
      <div className="mx-auto max-w-[1440px]">
        <FadeIn>
          <Eyebrow>The StrengthLeap Method</Eyebrow>
        </FadeIn>
        <FadeIn delay={0.1}>
          <h2 className="mt-8 max-w-4xl font-display text-4xl font-black uppercase leading-[0.95] tracking-tight sm:text-6xl lg:text-7xl">
            One continuous system. <span className="text-ash">Not five separate fixes.</span>
          </h2>
        </FadeIn>

        <div className="mt-20 grid gap-16 lg:grid-cols-[0.9fr_1.4fr] lg:gap-24">
          <div className="hidden lg:block">
            <div className="sticky top-32">
              <p className="font-display text-[11rem] font-black leading-none tracking-tight text-outline xl:text-[14rem]">
                {METHOD_STEPS[active].n}
              </p>
              <div className="mt-10 flex items-center gap-4">
                <div className="relative h-px w-40 bg-bone/15">
                  <motion.div
                    className="absolute left-0 top-0 h-px bg-lime"
                    animate={{ width: `${((active + 1) / METHOD_STEPS.length) * 100}%` }}
                    transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
                  />
                </div>
                <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-ash">
                  Phase {METHOD_STEPS[active].n} / 05
                </p>
              </div>
            </div>
          </div>

          <div>
            {METHOD_STEPS.map((s, i) => (
              <motion.div
                key={s.n}
                data-testid={`method-step-${s.n.toLowerCase()}`}
                onViewportEnter={() => setActive(i)}
                viewport={{ margin: "-45% 0px -45% 0px" }}
                className="flex min-h-[55vh] flex-col justify-center border-t border-bone/10 py-14 lg:min-h-[70vh]"
              >
                <FadeIn>
                  <p className={`font-mono text-xs uppercase tracking-[0.3em] transition-colors duration-500 ${active === i ? "text-lime" : "text-ash"}`}>
                    {s.n}
                  </p>
                  <h3 className="mt-4 font-display text-5xl font-black uppercase tracking-tight sm:text-7xl">
                    {s.title}
                  </h3>
                  <p className="mt-6 max-w-md text-base leading-relaxed text-ash sm:text-lg">{s.copy}</p>
                </FadeIn>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
